import { useSearchParams } from "react-router-dom";
import { AlertCircle } from "lucide-react";
import { Logo } from "@/components/Logo";

const GOOGLE_AUTH_URL =
  (import.meta.env.VITE_API_URL ?? "http://localhost:3333/api/v1") +
  "/auth/google";

const Login = () => {
  // Vem do backend (login Google) ou do api.ts (sessão derrubada) quando o RH desativou o usuário.
  const [params] = useSearchParams();
  const inativo = params.get("motivo") === "inativo";

  return (
    <div className="grid min-h-screen bg-background lg:grid-cols-2">
      {/* Painel da marca */}
      <div
        className="relative hidden flex-col justify-between gap-12 p-12 text-white lg:flex"
        style={{ background: "var(--gradient-dark)" }}
      >
        <Logo />
        <div className="flex max-w-[460px] flex-col gap-4">
          <h2 className="text-[40px] font-bold leading-[1.1] tracking-titulo">
            Gestão de Notas Fiscais{" "}
            <span className="text-[hsl(28_85%_58%)]">PJ</span>
          </h2>
          <p className="text-[15px] leading-relaxed opacity-80">
            Envie, acompanhe e aprove notas fiscais dos seus colaboradores PJ em
            um único lugar, por filial e com total rastreabilidade.
          </p>
        </div>
        <div className="text-xs opacity-60">
          © {new Date().getFullYear()} AceleraMais
        </div>
      </div>

      {/* Formulário */}
      <div className="flex items-center justify-center p-6">
        <div className="flex w-full max-w-[400px] flex-col gap-7">
          <div className="lg:hidden">
            <Logo fundo="claro" />
          </div>
          <div className="flex flex-col gap-2">
            <h1 className="text-[28px] font-bold tracking-titulo">Entrar</h1>
            <p className="text-sm text-muted-foreground">
              Acesse o sistema com sua conta Google corporativa
            </p>
          </div>

          {inativo && (
            <div
              role="alert"
              className="flex gap-2.5 rounded-lg border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900"
            >
              <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" />
              <span>
                Seu acesso está desativado. Se acha que é um engano, fale com
                Gente e Gestão.
              </span>
            </div>
          )}

          <button
            type="button"
            className="flex h-12 w-full items-center justify-center gap-3 rounded-[10px] border bg-card text-[15px] font-medium shadow-[0_2px_12px_-4px_hsl(210_33%_10%/0.08)] transition-colors hover:bg-row-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            onClick={() => (window.location.href = GOOGLE_AUTH_URL)}
          >
            <svg className="h-5 w-5" viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                fill="#4285F4"
              />
              <path
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                fill="#34A853"
              />
              <path
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                fill="#FBBC05"
              />
              <path
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                fill="#EA4335"
              />
            </svg>
            Entrar com Google
          </button>

          <p className="text-xs leading-normal text-muted-foreground">
            Use o seu e-mail corporativo. Se não conseguir entrar, fale com
            Gente e Gestão.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
